<template>
    <div class="navi-main">
        <div class="navi-home-bar">
            <div class="navi-category">
                <div v-for="(hbar, hIndex) in hBarList" class="navi-cate-item" :key="hbar.path">
                    <div class="navi-cate-item-label">
                        <router-link class="navi-cate-item-label2" :to="hbar.path" :exact="hIndex == 0 ? true : false">
                            {{ hbar.name }}
                        </router-link>
                    </div>
                    <div v-if="hIndex < hBarList.length - 1" class="navi-cate-item-divider"></div>
                </div>
            </div>
        </div>
        <div class='navi-footer-bar' style="display: none;">
            <div class="navi-1"></div>
            <div class="navi-2"></div>
            <div class="navi-3"></div>
        </div>
    </div>
</template>
<script>
import { forEach } from 'lodash';       //	lodash 工具库

const ITEM_KEY_1 = 'tag_category'
const ITEM_KEY_2 = 'category'
export default {
    components: {
    },
    props: {
        isMenuHidden: {   //  是否隐藏竖行导航栏
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ITEM_KEY_1,
            ITEM_KEY_2,
            menuHidden: this.isMenuHidden,
            activeTabKey: ITEM_KEY_2,
            hBarList: [
                {
                    path: '/',
                    name: '目录商品'
                },
                {
                    path: '/category/list',
                    name: '非库存商品'
                },
                {
                    path: '/about',
                    name: '联系我们'
                },
            ],
            tabItem1: {
                key: ITEM_KEY_1,
                label: '礼品攻略',
            },
            tabItem2: {
                key: ITEM_KEY_2,
                label: '商品分类',
            },
            categoryData: [],       //  商品分类
            tagCategoryData: [],    //  标签分类
            tagListData: [],
            showMenuContent: false,
            menuContent: [],
        }
    },
    created() {

    },
    watch: {
        '$route': function (event) {
            if (event.name == 'index') {
                this.menuHidden = false;
            } else {
                this.menuHidden = true;
            }
        }
    },
    mounted() {
        // this.loadingTagCategory();
        // this.loadingCategory();
        // window.addEventListener('scroll', this.onScroll, true);   //  增加滚动监听
    },
    methods: {
        /**
         * 监听滚动操作
         */
        onScroll() {
            if (this.$route.name == 'index') {
                let scrollTop = document.documentElement.scrollTop;
                if (scrollTop > 300) {
                    if (!this.menuHidden) {
                        this.menuHidden = true;
                    }
                } else {
                    if (this.menuHidden) {
                        this.menuHidden = false;
                    }
                }
                this.showMenuContent = false
            } else {
                this.menuHidden = true;
            }
        },
        /**
         * 点击Tab切换
         */
        handleTabsClick() {
            this.showMenuContent = false;
        },

        /**
         * 点击商品全部分类切换
         */
        handleMenu() {
            this.menuHidden = !this.menuHidden
            this.showMenuContent = false;
        },

        /**
         * 加载标签分类
         */
        loadingTagCategory() {
            this.$http.post('/tag/category-navigation').then(res => {
                if (res.ret == '0') {
                    this.tagCategoryData = res.data.category_list;
                    this.tagListData = res.data.tag_list;
                }
            });
        },

        /**
         * 加载商品分类
         */
        loadingCategory() {
            this.$http.post('/goods/category').then(res => {
                if (res.ret == '0') {
                    this.categoryData = res.data;
                }
            });
        },

        /**
         * 鼠标进入竖行导航区域
         */
        onMouseEnter() {
            // if (!this.showMenuContent) {
            //     this.showMenuContent = true;
            // }
            // console.log('onMouseEnter');
        },
        /**
         * 鼠标离开竖行导航区域
         */
        onMouseLeave() {
            if (this.showMenuContent) {
                this.showMenuContent = false;
            }
            // console.log('onMouseLeave');
        },

        /**
         * 鼠标进入栏目
         * @param {*} type  标识
         * @param {*} data  数据
         */
        onMouseEnterMenu(type, data) {
            if (!this.showMenuContent) {
                this.showMenuContent = true;
            }
            if (type == 'tag_category') {
                if (!this.$util.isEmpty(data.child)) {
                    forEach(data.child, (category, key) => {
                        if (!this.$util.isEmpty(this.tagListData[category['id']])) {
                            category['tag_list'] = this.tagListData[category['id']];
                        } else {
                            category['tag_list'] = [];
                        }
                    });
                }
            }
            this.menuContent = data.child;
        },
        // onMouseLeaveMenu(type, data) {
        //     console.log('onMouseLeaveMenu');
        // }
        /**
         * 跳转到标签标签频道
         * @param {*} data 
         */
        gotoTagCategoryUrl(data) {
            this.$util.navigationUrl({
                url: '/tag/category',
                page_params: {
                    id: data.id,
                },
            });
        },
        /**
         * 跳转到栏目分类
         * @param {*} data 
         */
        gotoCategoryUrl(data) {
            this.$util.navigationUrl({
                url: '/category/list',
                page_params: {
                    id: data.id,
                },
            });
        },
    },
}
</script>
<style lang='scss' scoped>
::v-deep(.el-tabs__item.is-active) {
    color: #80bd01;
}

::v-deep(.el-tabs__item:hover) {
    color: #80bd01;
}

::v-deep(.el-tabs__active-bar) {
    background-color: #80bd01;
}

.navi-home-bar {
    width: 68%;
    // margin: auto 16%;
    margin: auto;
    background-color: transparent;
    height: 36px;
    display: flex;
}

.navi-menu-container {
    width: 227px;
    min-width: 170px;
}

.navi-menu-title {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // font-weight: bold;
    color: #fff;
    background-color: #80BD01;
    border-radius: 5px 5px 0 0;
    font-size: 18px;
    letter-spacing: 2px;
}

.navi-menu-title-a {
    cursor: pointer;
}

.navi-menu-sidebar {
    position: absolute;
    top: 52px;
    left: 0;
    z-index: 22;
    width: 100%;
    background-color: #fff;
    border-radius: 0 0 5px 5px;
    // min-height: 500px;
    transition: all 0.4s;
    overflow-y: auto;
    // padding-bottom: 20px;
    box-shadow: 0 10px 20px 0 rgba(224, 221, 221, 0.4), 0 6px 20px 0 rgba(224, 221, 221, 0.4) !important;
}

.navi-menu-sidebar.hidden {
    height: 0px;
    min-height: 0px;
    padding-bottom: 0;
}

.sidebar-container {

    // padding: 6px 24px;
    .menu-list {
        color: #000000;
        display: flex;
        flex-direction: column;

        .menu-item {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            // border: red 1px solid;
            // height: 60px;
            height: 53px;
            margin: 5px 0px;
            padding-left: 10%;
            cursor: pointer;

            .icon {
                font-size: 18px;
                color: #777777;
            }

            .zk-yuangongfuli,
            .zk-gouwudai2 {
                font-size: 20px !important;
            }

            .zk-shuma,
            .zk-huodong {
                font-size: 16px !important;
            }


            .title {
                padding-left: 5%;
                font-size: 16px;
            }

            .zk-yuangongfuli_title,
            .zk-gouwudai2_title {
                padding-left: 4% !important;
            }

            .show-icon {
                position: absolute;
                right: 0;

                .more {
                    padding-right: 10px;
                }

            }
        }

        .menu-item:hover {
            background-color: #f2f8e5;
        }
    }
}

.navi-category {
    flex: 1;
    display: flex;

}

.navi-cate-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;
}

.menu-content {
    position: absolute;
    top: 52px;
    left: 227px;
    width: 600px;
    // width: 200px;
    background-color: #ffffff;
    color: #000;
    border: #80BD01 1px solid;
    padding: 20px;
    min-height: 520px;

    .child-menu {
        .menu-name {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
        }

        .child-conent {
            padding: 10px 0px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            span {
                border-right: #DCDCDC 1px solid;
                margin-bottom: 15px;
                padding-right: 15px;
                margin-right: 15px;
                font-size: 14px;
                color: #8D8D8E;

                a {
                    color: #8D8D8E;
                }
            }
        }
    }
}

.router-link-exact-active,
.router-link-active {
    color: #80BD01 !important;
    font-size: 18px;
    font-weight: 700;
}

.navi-cate-item-label {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    letter-spacing: 2px;

    .active {
        color: #80BD01 !important;
        font-size: 18px;
        font-weight: 700;
    }
}

.navi-cate-item-label2 {
    padding: 2px 8px;
    border-radius: 2px;
    color: #000;
    cursor: pointer;
}

.navi-cate-item-label2:hover {
    color: #80BD01;
}

.navi-cate-item-divider {
    width: 0;
    height: 14px;
    border-right: 1px solid #7F7F7F;
}

.navi-footer-bar {
    position: relative;
    height: 16px;
    background-color: #F8CF3C;
    display: flex;
}

.navi-1 {
    width: 13%;
    // flex: 1;
    background-color: #009A78;
}

.navi-2 {
    flex: 3;
    margin-left: -10px;
    background-color: #80BD01;
    clip-path: polygon(0 0%, 100% 0%, 98% 100%, 10px 100%);
}

.navi-3 {
    // width: 55%;
    flex: 6;
    background-color: #F8CF3C;
}

::-webkit-scrollbar {
    width: 8px;
    /*height: 4px;*/
}

::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    // background: rgba(0, 0, 0, 0.05);
    background: transparent;
}
</style>
<style scoped>
.el-tabs__header {
    margin: 0 !important;
}
</style>
